import { render, staticRenderFns } from "./ParagraphView.vue?vue&type=template&id=e200225c"
import script from "./ParagraphView.vue?vue&type=script&lang=js"
export * from "./ParagraphView.vue?vue&type=script&lang=js"
import style0 from "./ParagraphView.vue?vue&type=style&index=0&id=e200225c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports